import { render, staticRenderFns } from "./RecordRequestsInbox.vue?vue&type=template&id=19d71a0e&scoped=true"
import script from "./RecordRequestsInbox.vue?vue&type=script&lang=js"
export * from "./RecordRequestsInbox.vue?vue&type=script&lang=js"
import style0 from "./RecordRequestsInbox.vue?vue&type=style&index=0&id=19d71a0e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d71a0e",
  null
  
)

export default component.exports